(ns teamoesterreich.admin-mode.detail-filter.wanado-filter
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [reagent.core :as r]
            [teamoesterreich.util.helper :as h]             ;;(h/event-value e)
            [teamoesterreich.util.log :as log]))



(defn wait-do [!waiting? !loaded? event-fn]
  (fn [e]
    (let [val (h/event-value e)]
      (js/console.log "wait or do" @!waiting?)
      (when @!waiting? (js/clearTimeout @!waiting?))
      (reset! !waiting?
              (js/setTimeout
                (fn []
                  (event-fn val)
                  (reset! !waiting? false)
                  (reset! !loaded? false))
                500)))))

(defn wait-do-check [!waiting? !loaded? event-fn]
  (fn [e val]
    (js/console.log "wait or do" val)
    (event-fn val)
    (reset! !waiting? false)
    (reset! !loaded? false)))


(defn check-box [!waiting? !loaded? !detail-search name add-filter-key]

  [mui/form-control-label {:label   name :value "dst" :placement "start"
                           :control (r/as-element [mui/checkbox {:checked  (get-in @!detail-search [:add-filter-wanado add-filter-key])
                                                                 :onChange (wait-do-check !waiting? !loaded? (fn [val] (swap! !detail-search assoc-in [:add-filter-wanado add-filter-key] val)))
                                                                 }])}]

  )



(defn wanado-block [!detail-search !waiting? !loaded?]
  [mui/grid
   {:item  true
    :xs    12
    :style {:marginBottom "7px"}
    }

   [mui/paper
    [mui/grid
     {:container  true
      :direction  "row"
      :alignItems "flex-start"
      :justify    "flex-start"
      :spacing    1
      :style      {:padding "5px"}
      }

     [mui/grid
      {:item true
       :lg   2
       :md   3
       :xs   6
       }
      [mui/typography "Was ich tun will"]
      ]
     [mui/grid
      {:item true
       :md   9
       :xs   6
       }

      [mui/form-control
       {
        :component "fieldset"
        :fullWidth true
        }
       [mui/radio-group {:row true :class "filterRadio"}


        [check-box !waiting? !loaded? !detail-search "Katastrophe (Kat)" :helpingCat]
        [check-box !waiting? !loaded? !detail-search "Ohne Katastrophe (NoKat)" :helpingNoCat]
        [check-box !waiting? !loaded? !detail-search "Tafel" :helpingTafel]
        [check-box !waiting? !loaded? !detail-search "Lebensretter (LR)" :helpingLebensretter]
        [check-box !waiting? !loaded? !detail-search "Online" :helpingCrowdTasker]

        ]

       ]
      [mui/form-control
       {
        :component "fieldset"
        :fullWidth true
        }
       [mui/radio-group {:row true :class "filterRadio"}


        [check-box !waiting? !loaded? !detail-search "Körperlich" :helpingManualWork]
        [check-box !waiting? !loaded? !detail-search "Fachspezifisch" :helpingProfessionalSkills]
        [check-box !waiting? !loaded? !detail-search "Online" :helpingOnline]
        [check-box !waiting? !loaded? !detail-search "Dienstfreistellung" :helpingWorkHoursPossible]
        [check-box !waiting? !loaded? !detail-search "Eigenes Fahrzeug" :helpingOwnCar]

        ]

       ]

      ]]]])

